

class SelectCell extends UITableViewCell
{    
    private titleLabel:MUILabel = null;  

    awakeFromHTML() {
        this.titleLabel = MUIOutlet(this, 'title-lbl', 'MUILabel');
        this.separatorStyle = UITableViewCellSeparatorStyle.None;
    }

    set title(title:string) {
         this.titleLabel.text = title;
    }

    // Tree pickers: indent the title by depth. Always set (0 clears the
    // padding on cell reuse).
    set indentLevel(level:number) {
        this.titleLabel.layer.style.paddingLeft = ( ( level ?? 0 ) * 20 ) + "px";
    }
}
